<template>
  <div class="slot-static">
    <div class="slot-static__text max-container">
      <h2 class="slot-static__text-heading heading__content">{{ $t('Products') }}</h2>
    </div>
    <div class="slot-container max-container">
      <div class="slot-static__item--container" v-for="(card, index) in cards" :key="index">
        <div class="slot-static__item"
        data-aos="fade-up"
        data-aos-offset="-200"
        :data-aos-delay="200 * index"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        >
          <div class="slot-static__item--border">
            <img class="slot-static__item--img" :src="card.image" :alt="card.alt">
            <h4 class="slot-static__item--heading">{{ card.title }}</h4>
            <div class="slot-static__item--details" v-if="card.subtitle != null">
              <p class="slot-static__item--caption">{{ card.subtitle }}</p>
            </div>
            <button class="secondary-button secondary-button__basic button-animation" @click="openModal">{{$t('LOGIN')}}</button>
          </div>
          
        </div>
        <div class="carousel__item slot-static__card">
        </div>
      </div>
    </div>
  </div>
  <div class="slot-static-mobile">
    <SlotSlider/>
  </div>
  <ModalComponent ref="modal" />
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '@/components/modal.vue'
import 'vue3-carousel/dist/carousel.css'
import SlotSlider from '@/components/slots-slider.vue'
import { useI18n } from 'vue-i18n';
import { watch } from 'vue';

export default defineComponent({
  name: 'SlotStatic',
  components: {
    ModalComponent,
    SlotSlider
  },
    methods: {
      openModal() {
        this.$refs.modal.openModal();
      }
  },
  setup() {
    const { t , locale }  = useI18n();
    let cards= [
      {
        title      :  t('Sports'),
        subtitle   :  null,
        image      :  require('@/assets/images/sports.jpg'),
        alt        :  'Lorem ipsum',
      },
      {
        title      :  'CASINO',
        subtitle   :  null,
        image      :  require('@/assets/images/casino.jpg'),
        alt        :  'Lorem ipsum',
      },
      {
        title      :  t('Racebook'),
        subtitle   :  null,
        image      :  require('@/assets/images/racebook.jpg'),
        alt        :  'Lorem ipsum',
      }
    ]

    // Observar los cambios de idioma y actualiza los slides
    const updateSlides = () => {
        cards.forEach((slide, index) => {
          slide.title = t(`Slider.${index}.title`);
        });
      };

      // Escuchar los cambios de idioma y actualiza los slides
      watch(locale, () => {
        updateSlides();
      });
    return{
      cards
    }
  }})
</script>
